import React, { FC } from 'react';
import Link from 'next/link';
import Box from '@/components/UI/box/Box';
import Badges from '@/components/UI/badges/Badges';
import Carousel from '@/components/reusable/carousel/Carousel';
import { SplideSlide } from '@splidejs/react-splide';
import { HouseTag } from '@/components/houses/_types/productItem.types';
import { houseTagsCarouselSetting } from '@/components/houses/_constants';
import styles from './HouseTags.module.scss';
type HouseTagsProps = {
  tags: HouseTag[];
};
const HouseTags: FC<HouseTagsProps> = ({
  tags
}) => {
  return <Box className={styles['tags']} component={'section'} data-sentry-element="Box" data-sentry-component="HouseTags" data-sentry-source-file="HouseTags.tsx">
      <Carousel component="nav" opts={houseTagsCarouselSetting} data-sentry-element="Carousel" data-sentry-source-file="HouseTags.tsx">
        {tags?.map((tag, index) => <SplideSlide key={`HOUSE_TAGS_${index}`}>
            <Link href={tag.href}>
              <Badges label={tag.text} type="default" size="large" />
            </Link>
          </SplideSlide>)}
      </Carousel>
    </Box>;
};
export default HouseTags;